export const MAX_PANE_ITEMS = 8;
export const TEXT_SELECTION_MAX_PANE_ITEMS = 14;
